import { SpaTreatmentsCategoryVersion } from '@features/spa/pages/SpaTreatmentsCategory/SpaTreatmentsCategoryVersion';

import { fetchSpaCategories } from '@store/entity/actions';
import * as entityActions from '@store/entity/actions';
import { fetchSpaSettings } from '@store/setting/actions';
import * as journeyActions from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { entitySelectors } from '@store/entity/selectors';

import { QueryClient } from '@tanstack/react-query';
import {
  getSpaTreatmentsPagePrefetch,
  getAvailableSpaTreatmentsPrefetch,
} from '@features/spa/hooks';

import { UNCATEGORIZED_VALUE } from '@features/spa/utils/buildCategoryOptions';
import { Routes } from '@common/constants';
import { isNotFoundError } from '@common/helpers/isNotFoundError';
import { redirectToListing } from '@common/helpers/notFoundRedirect';

const SpaTreatmentsCategory = ({ property, category, language }) => {
  // The redirect is already in flight; the version below reads category.id.
  if (!category) {
    return null;
  }

  return (
    <div>
      <SpaTreatmentsCategoryVersion property={property} language={language} category={category} />
    </div>
  );
};

SpaTreatmentsCategory.getInitialProps = async ({ store, property, language, query, res }) => {
  const isUncategorized = query.id === UNCATEGORIZED_VALUE;

  if (property) {
    const { spaDate } = yourJourneySelectors.getParsedJourneyParams(store.getState());
    const client = new QueryClient();
    try {
      await Promise.all([
        ...(isUncategorized
          ? []
          : [
              // isOptional: false, or the action swallows the rejection and an
              // unknown category renders as a crash rather than a redirect.
              entityActions.fetchCategory(property.id, query.id, language, {
                isOptional: false,
              })(store.dispatch),
            ]),
        store.dispatch(journeyActions.changeJourneyParam('spaDate', spaDate)),
        getAvailableSpaTreatmentsPrefetch(
          client,
          property.id,
          language,
          null,
          isUncategorized ? null : Number(query.id)
        ),
        fetchSpaSettings(property.id)(store.dispatch),
        getSpaTreatmentsPagePrefetch(client, property.id, language),
        fetchSpaCategories(property.id, language)(store.dispatch),
      ]);
    } catch (error) {
      // Only an unknown category belongs on the listing. Anything else stays an
      // error.
      if (!isNotFoundError(error)) throw error;

      redirectToListing(res, Routes.SPA_TREATMENT_LIST, query);

      return { property, language, category: null };
    }
  }

  const category = isUncategorized
    ? { id: UNCATEGORIZED_VALUE, name: '', description: null, image: null }
    : entitySelectors.getCategory(store.getState(), query.id);

  return {
    property,
    category,
    language,
  };
};

export default SpaTreatmentsCategory;
